export const orderModalTranslations = {
  nl: {
    title: 'Kies je bestelplatform',
    subtitle: 'Selecteer je favoriete manier om te bestellen',
    thuisbezorgdDesc: 'Bestel via Thuisbezorgd',
    sitedishDesc: 'Bestel via Sitedish',
    cancel: 'Annuleren',
  },
  en: {
    title: 'Choose Your Order Platform',
    subtitle: 'Select your preferred ordering method',
    thuisbezorgdDesc: 'Order at Thuisbezorgd',
    sitedishDesc: 'Order at Sitedish',
    cancel: 'Cancel',
  },
};

